import useSWR from 'swr'
import { swrFetcher } from './helpers'
import { Form, FormRevision, Question } from './aboboApiTypes'


export const useFormRevision = (id: string | undefined, token: string | undefined) => {
  const { data: response, error, isLoading } = useSWR(
    id && token ? [`/form_revisions/${id}`, { headers: { Authorization: `Bearer ${token}` } }] : null,
    swrFetcher<FormRevision>,
    { revalidateOnFocus: false }
  )

  return {
    formRevision: response?.data,
    isLoading,
    isError: !!error,
    error: error as Error | undefined,
  }
}

export const useForm = (id, queryParams) => {
  const { data: response, error, isLoading } = useSWR([id ? `/forms/${id}`: null, {queryParams}], swrFetcher<Form>, {revalidateOnFocus: false})

  return {
    form: response?.data,
    isLoading,
    isError: error
  }
}

export const useFormQuestions = (formId) => {
  const { data: response, error } = useSWR(formId ? `/forms/${formId}/questions`: null, swrFetcher<Question[]>, {revalidateOnFocus: false})

  return {
    formQuestions: response?.data,
    getQuestion: (questionId) => {
      if (!response || !response.data) return

      return response.data.find((question) => question.id == questionId) 
    },
    isLoading: !error && !response,
    isError: error
  }
}